import * as React from "react";
import { sortBy } from "lodash";

import { nameToTitle } from "web_modules/capital_markets_dashboard/shared/utils";

import LoanTypesProvider, { LoanTypesContext } from "./LoanTypesProvider";
import RatesEditor from "./RatesEditor";
import RatesProvider from "./RatesProvider";
import TabSwitcher from "./TabPanelSwitcher";

const styles = require("./styles.module.scss");

const RatesPage = () => (
  <LoanTypesProvider>
    <LoanTypesContext.Consumer>
      {value => (
        <TabSwitcher>
          {sortBy(value.loanTypes, t => t.name).map(t => (
            <TabSwitcher.Panel key={t.id} label={nameToTitle(t.name)}>
              <div className={styles.container}>
                <RatesProvider loanType={t}>
                  <RatesEditor />
                </RatesProvider>
              </div>
            </TabSwitcher.Panel>
          ))}
        </TabSwitcher>
      )}
    </LoanTypesContext.Consumer>
  </LoanTypesProvider>
);

export default RatesPage;
